(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-announcements"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('vb-marquee')) {
    /**
     * ValoraaBead announcement marquee. Clones the message group until the line is at least twice
     * the viewport, then drifts it left by exactly one group width per cycle (seamless loop).
     * Clones are aria-hidden and inert. Hover, focus and the pause button hold it still; a
     * keyboard user tabbing in stops it and the focused link is scrolled into view.
     */
    class VbMarquee extends HTMLElement {
      #frame = 0;
      #observer = null;
      #reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
      #width = 0;
      #copies = 0;

      connectedCallback() {
        this.viewport = this.querySelector('[data-vb-marquee-viewport]');
        this.track = this.querySelector('[data-vb-marquee-track]');
        this.group = this.querySelector('[data-vb-marquee-group]');
        this.toggle = this.querySelector('[data-vb-marquee-toggle]');
        if (!this.viewport || !this.track || !this.group) return;

        this.toggle?.addEventListener('click', this.#onToggle);
        this.addEventListener('focusin', this.#onFocusIn);
        this.addEventListener('focusout', this.#onFocusOut);
        this.#reduce.addEventListener('change', this.#schedule);
        this.#observer = new ResizeObserver(this.#schedule);
        this.#observer.observe(this.viewport);
        this.#observer.observe(this.group);
        this.#schedule();
      }

      disconnectedCallback() {
        this.toggle?.removeEventListener('click', this.#onToggle);
        this.removeEventListener('focusin', this.#onFocusIn);
        this.removeEventListener('focusout', this.#onFocusOut);
        this.#reduce.removeEventListener('change', this.#schedule);
        this.#observer?.disconnect();
        cancelAnimationFrame(this.#frame);
      }

      #schedule = () => {
        cancelAnimationFrame(this.#frame);
        this.#frame = requestAnimationFrame(() => this.#build());
      };

      #build() {
        const items = this.group.children.length;
        if (this.#reduce.matches || items === 0) {
          this.#clearClones();
          this.#width = 0;
          this.#copies = 0;
          this.setAttribute('data-ready', '');
          if (this.toggle) this.toggle.hidden = true;
          return;
        }

        const width = this.group.getBoundingClientRect().width;
        const viewport = this.viewport.getBoundingClientRect().width;
        if (!width || !viewport) return;
        const copies = Math.max(2, Math.ceil((viewport * 2) / width));
        if (Math.abs(width - this.#width) < 0.5 && copies === this.#copies) return;

        this.#width = width;
        this.#copies = copies;
        this.#clearClones();
        for (let i = 1; i < copies; i += 1) {
          const clone = this.group.cloneNode(true);
          clone.removeAttribute('data-vb-marquee-group');
          clone.removeAttribute('role');
          clone.setAttribute('aria-hidden', 'true');
          clone.inert = true;
          clone.dataset.vbMarqueeClone = '';
          for (const el of clone.querySelectorAll('[data-shopify-editor-block], [id]')) {
            el.removeAttribute('data-shopify-editor-block');
            el.removeAttribute('id');
          }
          this.track.append(clone);
        }

        const rtl = getComputedStyle(this).direction === 'rtl';
        const speed = Math.max(5, Number(this.dataset.speed) || 40);
        this.style.setProperty('--vb-marquee-distance', `${rtl ? width : -width}px`);
        this.style.setProperty('--vb-marquee-duration', `${(width / speed).toFixed(2)}s`);
        this.setAttribute('data-ready', '');
        if (this.toggle) this.toggle.hidden = false;
      }

      #clearClones() {
        for (const clone of this.track.querySelectorAll('[data-vb-marquee-clone]')) clone.remove();
      }

      #onToggle = () => {
        const paused = this.toggle.getAttribute('aria-pressed') !== 'true';
        this.toggle.setAttribute('aria-pressed', String(paused));
        this.toggleAttribute('data-paused', paused);
      };

      /** @param {FocusEvent} event */
      #onFocusIn = (event) => {
        const target = /** @type {HTMLElement} */ (event.target);
        if (!this.group.contains(target) || !target.matches(':focus-visible')) return;
        this.setAttribute('data-keyboard', '');
        const view = this.viewport.getBoundingClientRect();
        const box = target.getBoundingClientRect();
        if (box.right > view.right) this.viewport.scrollLeft += box.right - view.right + 24;
        if (box.left < view.left) this.viewport.scrollLeft -= view.left - box.left + 24;
      };

      /** @param {FocusEvent} event */
      #onFocusOut = (event) => {
        if (this.contains(/** @type {Node} */ (event.relatedTarget))) return;
        this.removeAttribute('data-keyboard');
        this.viewport.scrollLeft = 0;
      };
    }

    customElements.define('vb-marquee', VbMarquee);
  }

  /* Rotate mode: slides hidden from screen readers are also made inert, so a link in an
     outgoing slide can't take focus during the fade (axe aria-hidden-focus). */
  (() => {
    const syncInert = (root = document) => {
      for (const slide of root.querySelectorAll('.announcement-bar__slide')) {
        slide.inert = slide.getAttribute('aria-hidden') === 'true';
      }
    };
    const watch = () => {
      syncInert();
      for (const slides of document.querySelectorAll('.announcement-bar__slides')) {
        new MutationObserver(() => syncInert(slides)).observe(slides, {
          subtree: true,
          attributes: true,
          attributeFilter: ['aria-hidden'],
        });
      }
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch);
    else watch();
    document.addEventListener('shopify:section:load', watch);
  })();

  /*
    ValoraaBead: in "one line" desktop mode every message is visible at 990px and up, so rotation
    pauses and no message is hidden from screen readers. Below 990px the Horizon rotation resumes.
  */
  (() => {
    const query = window.matchMedia('(min-width: 990px)');

    const sync = () => {
      for (const bar of document.querySelectorAll('.announcement-bar__slider--vb-inline')) {
        if (typeof bar.pause !== 'function') continue;
        const slides = bar.querySelectorAll('.announcement-bar__slide');
        if (query.matches) {
          bar.pause();
          bar.removeAttribute('aria-live');
          for (const slide of slides) slide.setAttribute('aria-hidden', 'false');
        } else if (bar.paused) {
          bar.paused = false;
          bar.setAttribute('aria-live', 'polite');
          bar.current = 0;
          bar.play();
        }
      }
    };

    customElements.whenDefined('announcement-bar-component').then(sync);
    query.addEventListener('change', sync);
    document.addEventListener('shopify:section:load', () => customElements.whenDefined('announcement-bar-component').then(sync));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vb-charm-tiles"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.vbH1RowFocus) return;
    window.vbH1RowFocus = true;
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    /** @param {Element} row */
    const scrollable = (row) => row.scrollWidth > row.clientWidth + 1;

    /* Swipe rows: bring a keyboard-focused tile or card fully into view (start-aligned, like the snap) */
    document.addEventListener('focusin', (event) => {
      const target = event.target;
      if (!(target instanceof Element)) return;
      const row = target.closest('[data-vb-h1-row]');
      if (!row || !scrollable(row)) return;
      const item = target.closest('li') || target;
      const box = item.getBoundingClientRect();
      const rowBox = row.getBoundingClientRect();
      const pad = parseFloat(getComputedStyle(row).scrollPaddingInlineStart) || 0;
      if (box.left >= rowBox.left + pad - 1 && box.right <= rowBox.right + 1) return;
      row.scrollTo({ left: row.scrollLeft + (box.left - rowBox.left - pad), behavior: reduced.matches ? 'auto' : 'smooth' });
    });

    /* Mouse drag-to-scroll (tablet widths in a desktop browser have no swipe); a drag never clicks */
    let drag = null;
    document.addEventListener('pointerdown', (event) => {
      if (event.pointerType !== 'mouse' || event.button !== 0 || !(event.target instanceof Element)) return;
      const row = event.target.closest('[data-vb-h1-row]');
      if (!row || !scrollable(row)) return;
      drag = { row, x: event.clientX, left: row.scrollLeft, moved: false };
    });
    document.addEventListener('pointermove', (event) => {
      if (!drag) return;
      const dx = event.clientX - drag.x;
      if (!drag.moved && Math.abs(dx) < 6) return;
      if (!drag.moved) {
        drag.moved = true;
        drag.row.setAttribute('data-dragging', '');
      }
      drag.row.scrollLeft = drag.left - dx;
    });
    const end = () => {
      if (!drag) return;
      const { row, moved } = drag;
      drag = null;
      if (!moved) return;
      row.removeAttribute('data-dragging');
      const block = (e) => {
        e.preventDefault();
        e.stopPropagation();
      };
      row.addEventListener('click', block, { capture: true });
      setTimeout(() => row.removeEventListener('click', block, { capture: true }), 0);
    };
    document.addEventListener('pointerup', end);
    document.addEventListener('pointercancel', end);
    document.addEventListener('dragstart', (event) => {
      if (event.target instanceof Element && event.target.closest('[data-vb-h1-row]')) event.preventDefault();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vb-connect"] && !Shopify.designMode) return;
  try {
    
  /**
   * Contact form: checks the required fields in the browser before posting. Each problem
   * field gets aria-invalid, its own message (aria-describedby) and the first one takes focus.
   * After Shopify posts back, the success or error notice is moved into view and focused.
   */
  class VbConnectForm extends HTMLElement {
    #form = null;
    #fields = [];

    connectedCallback() {
      this.#form = this.querySelector('form');
      if (!this.#form) return;
      this.#fields = [...this.#form.querySelectorAll('[data-vb-error]')];
      this.#form.noValidate = true;
      /* Capture phase, so an invalid form never reaches Shopify's own submit handlers (bot check). */
      this.#form.addEventListener('submit', this.#onSubmit, { capture: true });
      this.#form.addEventListener('input', this.#onInput);
      const notice = this.querySelector('[data-vb-connect-notice]');
      if (notice) requestAnimationFrame(() => notice.focus({ preventScroll: false }));
      notice?.addEventListener('click', this.#onNoticeLink);
    }

    /* A link in the error summary jumps to its field; move focus there too, so typing can start. */
    #onNoticeLink = (event) => {
      const link = event.target instanceof Element ? event.target.closest('a[href^="#"]') : null;
      if (!link) return;
      const field = document.getElementById(link.getAttribute('href').slice(1));
      if (!field) return;
      event.preventDefault();
      field.focus();
    };

    disconnectedCallback() {
      this.#form?.removeEventListener('submit', this.#onSubmit, { capture: true });
      this.#form?.removeEventListener('input', this.#onInput);
    }

    #onSubmit = (event) => {
      let first = null;
      for (const field of this.#fields) {
        if (field.type !== 'textarea') field.value = field.value.trim();
        const ok = field.checkValidity();
        this.#mark(field, !ok);
        if (!ok && !first) first = field;
      }
      if (!first) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      first.focus();
    };

    #onInput = (event) => {
      const field = event.target;
      if (!(field instanceof HTMLElement) || !field.hasAttribute('data-vb-error')) return;
      if (field.getAttribute('aria-invalid') === 'true' && field.checkValidity()) this.#mark(field, false);
    };

    /** @param {HTMLInputElement|HTMLTextAreaElement} field @param {boolean} invalid */
    #mark(field, invalid) {
      const message = field.parentElement?.querySelector('.vb-connect__error');
      if (!message) return;
      if (!invalid) {
        field.removeAttribute('aria-invalid');
        field.removeAttribute('aria-describedby');
        message.hidden = true;
        message.textContent = '';
        return;
      }
      field.setAttribute('aria-invalid', 'true');
      field.setAttribute('aria-describedby', message.id);
      message.textContent = field.dataset.vbError || '';
      message.hidden = false;
    }
  }

  if (!customElements.get('vb-connect-form')) customElements.define('vb-connect-form', VbConnectForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vb-contact-hero"] && !Shopify.designMode) return;
  try {
    
  // Studio status pill: open or closed right now in Indian time (Asia/Kolkata), from the section's
  // opening days and hours. Computed in the visitor's browser, so it is never a stale claim.
  if (!customElements.get('vb-studio-status')) {
    const TZ = 'Asia/Kolkata';
    const WEEKDAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

    /**
     * The current weekday (0 = Sunday) and minute of the day in IST.
     * @typedef {Object} IndiaNow
     * @property {number} day
     * @property {number} minutes
     * @returns {IndiaNow}
     */
    const nowInIndia = () => {
      const parts = new Intl.DateTimeFormat('en-US', {
        timeZone: TZ,
        weekday: 'short',
        hour: 'numeric',
        minute: 'numeric',
        hourCycle: 'h23',
      }).formatToParts(new Date());
      const get = (type) => parts.find((part) => part.type === type)?.value || '';
      return {
        day: WEEKDAYS.indexOf(get('weekday')),
        minutes: (Number(get('hour')) % 24) * 60 + Number(get('minute')),
      };
    };

    /** English weekday name for 0 = Sunday … 6 = Saturday (any week works: 2024-01-07 was a Sunday) */
    const dayName = (day, locale) =>
      new Intl.DateTimeFormat(locale, { weekday: 'long', timeZone: 'UTC' }).format(new Date(Date.UTC(2024, 0, 7 + day)));

    class VbStudioStatus extends HTMLElement {
      connectedCallback() {
        this.update();
        this.timer = window.setInterval(() => this.update(), 60000);
      }

      disconnectedCallback() {
        window.clearInterval(this.timer);
      }

      update() {
        const text = this.querySelector('[data-vb-status-text]');
        const dot = this.querySelector('[data-vb-status-dot]');
        if (!text || !dot) return;
        const days = (this.dataset.days || '').split(',').filter((d) => d !== '').map(Number);
        const open = Number(this.dataset.openHour) * 60;
        const close = Number(this.dataset.closeHour) * 60;
        // No opening days or impossible hours: keep the neutral reply-time line
        if (days.length === 0 || !(close > open)) return;

        let now;
        try {
          now = nowInIndia();
        } catch {
          return;
        }
        if (now.day < 0 || Number.isNaN(now.minutes)) return;

        const isOpen = days.includes(now.day) && now.minutes >= open && now.minutes < close;
        let message = '';
        if (isOpen) {
          message = this.dataset.openText || '';
        } else {
          let ahead = 0;
          if (!(days.includes(now.day) && now.minutes < open)) {
            ahead = [1, 2, 3, 4, 5, 6, 7].find((n) => days.includes((now.day + n) % 7)) || 0;
          }
          const locale = document.documentElement.lang || 'en';
          let when = this.dataset.today || '';
          if (ahead === 1) when = this.dataset.tomorrow || '';
          if (ahead > 1) when = (this.dataset.onDay || '').replace('[day]', dayName((now.day + ahead) % 7, locale));
          message = (this.dataset.closedText || '').replace('[day]', when);
        }
        if (!message) return;
        text.textContent = message;
        dot.hidden = !isOpen;
        this.hidden = false;
      }
    }

    customElements.define('vb-studio-status', VbStudioStatus);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vb-contact"] && !Shopify.designMode) return;
  try {
    
  // Topic chips set the topic <select> (and follow it); links with data-vb-contact-topic
  // (e.g. the "Start a request" card) pick a topic before jumping to the form.
  if (!customElements.get('vb-contact-topics')) {
    class VbContactTopics extends HTMLElement {
      connectedCallback() {
        this.select = this.querySelector('[data-vb-topic-select]');
        if (!this.select) return;
        this.onChipClick = (event) => {
          const chip = event.target.closest('[data-vb-topic-chip]');
          if (!chip || !this.contains(chip)) return;
          const value = chip.dataset.value || '';
          this.setTopic(this.select.value === value ? '' : value);
        };
        this.onSelectChange = () => this.sync();
        this.addEventListener('click', this.onChipClick);
        this.select.addEventListener('change', this.onSelectChange);
        this.sync();
        // Links from other pages pick a topic with ?topic=<word>, e.g. /pages/contact?topic=custom#contact-form
        const wanted = new URLSearchParams(window.location.search).get('topic');
        if (wanted && !this.setTopic(wanted)) {
          const word = wanted.trim().toLowerCase();
          const option = Array.from(this.select.options).find((opt) => opt.value && opt.value.toLowerCase().includes(word));
          if (option) this.setTopic(option.value);
        }
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onChipClick);
        this.select?.removeEventListener('change', this.onSelectChange);
      }

      setTopic(value) {
        if (!this.select) return false;
        const wanted = String(value || '').trim().toLowerCase();
        const option = Array.from(this.select.options).find((opt) => opt.value.trim().toLowerCase() === wanted);
        if (!option) return false;
        this.select.value = option.value;
        this.select.dispatchEvent(new Event('change', { bubbles: true }));
        return true;
      }

      sync() {
        const current = this.select.value;
        this.querySelectorAll('[data-vb-topic-chip]').forEach((chip) => {
          chip.setAttribute('aria-pressed', String(current !== '' && chip.dataset.value === current));
        });
      }
    }

    customElements.define('vb-contact-topics', VbContactTopics);

    document.addEventListener('click', (event) => {
      const link = event.target instanceof Element ? event.target.closest('[data-vb-contact-topic]') : null;
      if (!link) return;
      const topics = document.querySelector('vb-contact-topics');
      if (topics && typeof topics.setTopic === 'function') topics.setTopic(link.getAttribute('data-vb-contact-topic'));
    });

    // Shopify refills name, email, phone and message after a failed post, but not the order number
    // or topic: keep those in sessionStorage on submit and put them back when the error shows.
    const KEEP_KEY = 'vb-contact-keep';
    const storage = (() => {
      try {
        return window.sessionStorage;
      } catch {
        return null;
      }
    })();
    document.addEventListener('submit', (event) => {
      const form = event.target instanceof HTMLFormElement ? event.target : null;
      if (!form || !storage || !form.querySelector('[data-vb-contact-keep]')) return;
      const kept = {};
      form.querySelectorAll('[data-vb-contact-keep]').forEach((field) => {
        kept[field.name] = field.value;
      });
      try {
        storage.setItem(KEEP_KEY, JSON.stringify(kept));
      } catch {}
    });
    if (storage) {
      try {
        if (document.querySelector('[data-vb-contact-error]')) {
          const kept = JSON.parse(storage.getItem(KEEP_KEY) || '{}');
          document.querySelectorAll('[data-vb-contact-keep]').forEach((field) => {
            if (!(field.name in kept)) return;
            field.value = kept[field.name];
            if (field.tagName === 'SELECT') field.dispatchEvent(new Event('change', { bubbles: true }));
          });
        } else if (document.querySelector('[data-vb-contact-success]')) {
          storage.removeItem(KEEP_KEY);
        }
      } catch {}
    }

    // Designed inline validation instead of the browser's bubbles (progressive: without JavaScript
    // the browser's own checks still run, because novalidate is only added here).
    const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
    const errorFor = (field) => {
      const value = field.value.trim();
      if (field.type === 'email') {
        if (!value) return field.dataset.vbErrorBlank || '';
        if (!EMAIL_RE.test(value)) return field.dataset.vbErrorFormat || '';
        return '';
      }
      if (field.required && !value) return field.dataset.vbErrorBlank || '';
      return '';
    };
    const showError = (field, message) => {
      const box = field.id ? document.getElementById(`${field.id}-error`) : null;
      if (!box) return;
      if (message) {
        box.textContent = message;
        box.hidden = false;
        field.setAttribute('aria-invalid', 'true');
        field.setAttribute('aria-describedby', box.id);
      } else {
        box.textContent = '';
        box.hidden = true;
        field.removeAttribute('aria-invalid');
        field.removeAttribute('aria-describedby');
      }
    };
    document.querySelectorAll('form[data-vb-contact-validate]').forEach((form) => {
      form.noValidate = true;
      const fields = Array.from(form.querySelectorAll('[data-vb-error-blank]'));
      form.addEventListener('submit', (event) => {
        let first = null;
        for (const field of fields) {
          const message = errorFor(field);
          showError(field, message);
          if (message && !first) first = field;
        }
        if (!first) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        first.focus();
      }, true);
      for (const field of fields) {
        // once a field has been flagged, clear (or update) its message as the shopper fixes it
        field.addEventListener('input', () => {
          if (field.getAttribute('aria-invalid') === 'true') showError(field, errorFor(field));
        });
      }
    });

    // After a post, move focus to the success or error message so it is announced and visible.
    const notice = document.querySelector('[data-vb-contact-notice]');
    if (notice) {
      requestAnimationFrame(() => {
        notice.focus({ preventScroll: true });
        notice.scrollIntoView({ block: 'center' });
      });
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vb-craft-video"] && !Shopify.designMode) return;
  try {
    
  /* Autoplay (setting): the film plays muted and looping while the section is on screen and pauses
     off screen (it only starts downloading when it first comes into view). It is background motion
     only: no sound, no player bar, no running time. Visitors who prefer reduced motion get the
     play button instead: the full film is cloned from its template only then, so the page never
     downloads it unless asked. */
  if (!customElements.get('vb-craft-video')) {
    customElements.define(
      'vb-craft-video',
      class extends HTMLElement {
        connectedCallback() {
          this.ambient = this.querySelector('[data-vb-cv-ambient]');
          this.querySelector('[data-vb-cv-play]')?.addEventListener('click', () => this.play());
          const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          if (!this.ambient || reduced) return;
          this.setAttribute('data-ambient', '');
          this.ambient.muted = true;
          this.ambient.addEventListener('playing', () => this.setAttribute('data-ambient-on', ''), { once: true });
          this.observer = new IntersectionObserver(
            (entries) => {
              for (const entry of entries) {
                if (entry.isIntersecting) this.ambient.play().catch(() => {});
                else this.ambient.pause();
              }
            },
            { threshold: 0.25 }
          );
          this.observer.observe(this);
        }

        disconnectedCallback() {
          this.observer?.disconnect();
        }

        play() {
          const template = this.querySelector('template[data-vb-cv-template]');
          if (!(template instanceof HTMLTemplateElement)) return;
          const node = template.content.firstElementChild?.cloneNode(true);
          if (!(node instanceof HTMLElement)) return;
          const video = node instanceof HTMLVideoElement ? node : node.querySelector('video');
          this.append(node);
          this.setAttribute('data-playing', '');
          video?.play().catch(() => {});
          video?.focus();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vb-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('vb-hero-video')) return;

    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    const phone = window.matchMedia('(max-width: 749px)');

    /* Performance: the poster is the LCP image; the video only starts after the page has loaded
       (plus an idle moment). It never loads under Save-Data or on slow-2g / 2g / 3g, and on
       phones (below 750px) not when the measured downlink is under 1.5 Mbps: the poster stays. */
    const connection = navigator.connection;
    const lightData = () => {
      if (!connection) return false;
      if (connection.saveData) return true;
      if (/^(slow-2g|2g|3g)$/.test(connection.effectiveType || '')) return true;
      return phone.matches && typeof connection.downlink === 'number' && connection.downlink > 0 && connection.downlink < 1.5;
    };
    const afterLoad = new Promise((resolve) => {
      const idle = () => ('requestIdleCallback' in window ? requestIdleCallback(() => resolve(), { timeout: 2500 }) : setTimeout(resolve, 600));
      if (document.readyState === 'complete') idle();
      else window.addEventListener('load', idle, { once: true });
    });

    /** Plays the hero video only while it is visible, the tab is shown and motion is welcome. */
    class VbHeroVideo extends HTMLElement {
      #abort = new AbortController();
      #observer = null;
      #visible = false;
      #loaded = false;

      connectedCallback() {
        this.wraps = [...this.querySelectorAll('[data-vb-hero-video]')];
        if (this.wraps.length === 0) return;

        const { signal } = this.#abort;

        for (const wrap of this.wraps) {
          const video = wrap.querySelector('video');
          if (!video) continue;
          video.muted = true;
          video.loop = true;
          video.playsInline = true;
          video.removeAttribute('controls');
          video.addEventListener('playing', () => wrap.setAttribute('data-ready', ''), { signal });
        }

        reduced.addEventListener('change', () => this.#update(), { signal });
        phone.addEventListener('change', () => this.#update(), { signal });
        document.addEventListener('visibilitychange', () => this.#update(), { signal });
        connection?.addEventListener?.('change', () => this.#update(), { signal });

        this.#observer = new IntersectionObserver(
          (entries) => {
            for (const entry of entries) this.#visible = entry.isIntersecting;
            this.#update();
          },
          { threshold: 0.15 }
        );
        afterLoad.then(() => {
          this.#loaded = true;
          this.#observer.observe(this);
        });
      }

      disconnectedCallback() {
        this.#abort.abort();
        this.#observer?.disconnect();
      }

      /** @returns {HTMLElement | undefined} */
      #activeWrap() {
        const wanted = phone.matches ? 'mobile' : 'desktop';
        return (
          this.wraps.find((wrap) => wrap.dataset.vbHeroVideo === wanted) ||
          this.wraps.find((wrap) => wrap.dataset.vbHeroVideo === 'all')
        );
      }

      #update() {
        const active = this.#activeWrap();
        for (const wrap of this.wraps) {
          if (wrap !== active) wrap.querySelector('video')?.pause();
        }

        const video = active?.querySelector('video');
        const shouldPlay =
          Boolean(video) && this.#loaded && this.#visible && !document.hidden && !reduced.matches && !lightData();

        if (!video) return;
        if (shouldPlay) {
          if (!video.getAttribute('src') && video.dataset.src) {
            video.preload = 'auto';
            video.src = video.dataset.src;
            video.load();
          }
          const attempt = video.play();
          if (attempt) attempt.catch(() => {});
        } else {
          video.pause();
        }
      }
    }

    customElements.define('vb-hero-video', VbHeroVideo);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vb-home-reviews"] && !Shopify.designMode) return;
  try {
    
  /* Keeps the review row focusable only while it scrolls sideways (the mobile swipe row). */
  if (!customElements.get('vb-reviews-scroller')) {
    customElements.define(
      'vb-reviews-scroller',
      class VbReviewsScroller extends HTMLElement {
        connectedCallback() {
          this.update = this.update.bind(this);
          this.observer = new ResizeObserver(this.update);
          this.observer.observe(this);
          this.update();
        }

        disconnectedCallback() {
          this.observer?.disconnect();
        }

        update() {
          if (this.scrollWidth > this.clientWidth + 1) {
            this.setAttribute('tabindex', '0');
          } else {
            this.removeAttribute('tabindex');
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vb-instagram"] && !Shopify.designMode) return;
  try {
    
  /**
   * Sideways photo row. While the row overflows it shows the previous / next arrows (fine
   * pointers only, via CSS), disables each one at its end of the row, and scrolls by the tiles
   * that fit. The row itself takes keyboard focus (tabindex=0) only if it scrolls and holds no
   * links, so keyboard users can still scroll it with the arrow keys.
   */
  class VbScrollRow extends HTMLElement {
    #observer = null;
    #scroller = null;
    #prev = null;
    #next = null;
    #reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

    connectedCallback() {
      this.#scroller = this.querySelector('[data-vb-scroller]') || this;
      this.#prev = this.querySelector('[data-vb-prev]');
      this.#next = this.querySelector('[data-vb-next]');
      this.#prev?.addEventListener('click', this.#onPrev);
      this.#next?.addEventListener('click', this.#onNext);
      this.#scroller.addEventListener('scroll', this.#onScroll, { passive: true });
      this.#observer = new ResizeObserver(() => this.#sync());
      this.#observer.observe(this.#scroller);
      this.#sync();
    }

    disconnectedCallback() {
      this.#observer?.disconnect();
      this.#prev?.removeEventListener('click', this.#onPrev);
      this.#next?.removeEventListener('click', this.#onNext);
      this.#scroller?.removeEventListener('scroll', this.#onScroll);
    }

    #onPrev = () => this.#page(-1);
    #onNext = () => this.#page(1);
    #onScroll = () => this.#syncArrows();

    /** @param {number} direction */
    #page(direction) {
      const item = this.#scroller.querySelector('li');
      const tile = item ? item.getBoundingClientRect().width : this.#scroller.clientWidth;
      const perView = Math.max(1, Math.floor(this.#scroller.clientWidth / tile));
      const rtl = getComputedStyle(this.#scroller).direction === 'rtl' ? -1 : 1;
      this.#scroller.scrollBy({
        left: direction * rtl * perView * tile,
        behavior: this.#reduced.matches ? 'auto' : 'smooth',
      });
    }

    #sync() {
      const scrolls = this.#scroller.scrollWidth > this.#scroller.clientWidth + 1;
      const hasLinks = Boolean(this.#scroller.querySelector('a[href]'));
      if (scrolls && !hasLinks) this.#scroller.setAttribute('tabindex', '0');
      else this.#scroller.removeAttribute('tabindex');
      for (const button of [this.#prev, this.#next]) {
        if (button) button.hidden = !scrolls;
      }
      this.#syncArrows();
    }

    #syncArrows() {
      if (!this.#prev || !this.#next) return;
      const max = this.#scroller.scrollWidth - this.#scroller.clientWidth;
      const position = Math.abs(this.#scroller.scrollLeft);
      this.#setDisabled(this.#prev, position <= 1, this.#next);
      this.#setDisabled(this.#next, position >= max - 1, this.#prev);
    }

    /** @param {HTMLButtonElement} button @param {boolean} disabled @param {HTMLButtonElement} other */
    #setDisabled(button, disabled, other) {
      if (button.disabled === disabled) return;
      const hadFocus = document.activeElement === button;
      button.disabled = disabled;
      /* A button that disables under the keyboard would drop focus to the page, so hand it over. */
      if (disabled && hadFocus && !other.disabled && !other.hidden) other.focus();
    }
  }

  if (!customElements.get('vb-scroll-row')) customElements.define('vb-scroll-row', VbScrollRow);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vb-polaroid-products"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.vbH1RowFocus) return;
    window.vbH1RowFocus = true;
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    /** @param {Element} row */
    const scrollable = (row) => row.scrollWidth > row.clientWidth + 1;

    /* Swipe rows: bring a keyboard-focused tile or card fully into view (start-aligned, like the snap) */
    document.addEventListener('focusin', (event) => {
      const target = event.target;
      if (!(target instanceof Element)) return;
      const row = target.closest('[data-vb-h1-row]');
      if (!row || !scrollable(row)) return;
      const item = target.closest('li') || target;
      const box = item.getBoundingClientRect();
      const rowBox = row.getBoundingClientRect();
      const pad = parseFloat(getComputedStyle(row).scrollPaddingInlineStart) || 0;
      if (box.left >= rowBox.left + pad - 1 && box.right <= rowBox.right + 1) return;
      row.scrollTo({ left: row.scrollLeft + (box.left - rowBox.left - pad), behavior: reduced.matches ? 'auto' : 'smooth' });
    });

    /* Mouse drag-to-scroll (tablet widths in a desktop browser have no swipe); a drag never clicks */
    let drag = null;
    document.addEventListener('pointerdown', (event) => {
      if (event.pointerType !== 'mouse' || event.button !== 0 || !(event.target instanceof Element)) return;
      const row = event.target.closest('[data-vb-h1-row]');
      if (!row || !scrollable(row)) return;
      drag = { row, x: event.clientX, left: row.scrollLeft, moved: false };
    });
    document.addEventListener('pointermove', (event) => {
      if (!drag) return;
      const dx = event.clientX - drag.x;
      if (!drag.moved && Math.abs(dx) < 6) return;
      if (!drag.moved) {
        drag.moved = true;
        drag.row.setAttribute('data-dragging', '');
      }
      drag.row.scrollLeft = drag.left - dx;
    });
    const end = () => {
      if (!drag) return;
      const { row, moved } = drag;
      drag = null;
      if (!moved) return;
      row.removeAttribute('data-dragging');
      const block = (e) => {
        e.preventDefault();
        e.stopPropagation();
      };
      row.addEventListener('click', block, { capture: true });
      setTimeout(() => row.removeEventListener('click', block, { capture: true }), 0);
    };
    document.addEventListener('pointerup', end);
    document.addEventListener('pointercancel', end);
    document.addEventListener('dragstart', (event) => {
      if (event.target instanceof Element && event.target.closest('[data-vb-h1-row]')) event.preventDefault();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vb-product-carousel"] && !Shopify.designMode) return;
  try {
    
  /* Load assets/vb-shop.js (Add to cart + photo warm-up) once per page, however many carousels
     the page has. Each carousel carries the module's URL; the first one found is used. */
  (() => {
    let loaded = false;
    const load = () => {
      if (loaded) return;
      const host = document.querySelector('[data-vb-shop-js]');
      if (!(host instanceof HTMLElement) || !host.dataset.vbShopJs) return;
      loaded = true;
      import(host.dataset.vbShopJs).catch(() => {
        loaded = false;
      });
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', load, { once: true });
    } else {
      load();
    }
    document.addEventListener('shopify:section:load', load);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vb-seen-on-you"] && !Shopify.designMode) return;
  try {
    
  /* When every photo fits (desktop), the row is not a scroll region: no tab stop. The tab stop
     comes back as soon as the row overflows (tablet, phones). */
  (() => {
    const sync = (viewport) => {
      const scrolls = viewport.scrollWidth > viewport.clientWidth + 1;
      if (scrolls) {
        viewport.setAttribute('tabindex', '0');
      } else {
        viewport.removeAttribute('tabindex');
      }
    };
    const observer = new ResizeObserver((entries) => {
      for (const entry of entries) sync(/** @type {HTMLElement} */ (entry.target));
    });
    const init = (root) => {
      for (const viewport of root.querySelectorAll('[data-vb-seen-viewport]')) {
        sync(viewport);
        observer.observe(viewport);
      }
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
    } else {
      init(document);
    }
    document.addEventListener('shopify:section:load', (event) => init(/** @type {HTMLElement} */ (event.target)));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vb-statement"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

    const init = (root) => {
      if (root.dataset.vbStatementReady) return;
      root.dataset.vbStatementReady = 'true';
      const videos = [...root.querySelectorAll('[data-vb-statement-video] video')];
      const toggle = root.querySelector('[data-vb-statement-toggle]');
      if (!videos.length) return;

      // Videos render with preload="none" and no autoplay: only the visible variant is fetched,
      // and only once the block scrolls near the viewport.
      let userPaused = reduce.matches;
      let inView = false;
      const visible = () => videos.filter((v) => v.offsetParent !== null);
      const apply = () => {
        const shown = visible();
        for (const v of videos) {
          if (userPaused || !inView || !shown.includes(v)) {
            v.pause();
            continue;
          }
          v.muted = true;
          if (v.preload !== 'auto') v.preload = 'auto';
          v.play().catch(() => {});
        }
        toggle?.setAttribute('aria-pressed', String(userPaused));
      };

      toggle?.addEventListener('click', () => {
        userPaused = toggle.getAttribute('aria-pressed') !== 'true';
        apply();
      });
      // Honour a reduced-motion switch made mid-session, not only the setting at load.
      reduce.addEventListener('change', (e) => {
        if (!e.matches) return;
        userPaused = true;
        apply();
      });
      new IntersectionObserver((entries) => {
        inView = entries.some((e) => e.isIntersecting);
        apply();
      }, { rootMargin: '200px 0px' }).observe(root);
      window.addEventListener('resize', apply);
      apply();
    };

    const run = () => {
      for (const el of document.querySelectorAll('.vb-statement')) init(el);
    };
    run();
    document.addEventListener('shopify:section:load', run);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vb-styled-on-you"] && !Shopify.designMode) return;
  try {
    
  /* Side arrows for the photo row: they scroll by one card, switch off at either end, and show
     only when the row is wider than its box (data-overflow); hover reveals them (CSS). */
  if (!customElements.get('vb-styled-rail')) {
    customElements.define(
      'vb-styled-rail',
      class extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-vb-styled-track]');
          this.prev = this.querySelector('[data-vb-styled-prev]');
          this.next = this.querySelector('[data-vb-styled-next]');
          if (!this.track || !this.prev || !this.next) return;
          this.prev.addEventListener('click', () => this.go(-1));
          this.next.addEventListener('click', () => this.go(1));
          this.track.addEventListener('scroll', () => this.update(), { passive: true });
          this.resize = new ResizeObserver(() => this.update());
          this.resize.observe(this.track);
          this.update();
        }

        disconnectedCallback() {
          this.resize?.disconnect();
        }

        step() {
          const card = this.track.querySelector('.vb-styled__card');
          const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
          return card ? card.getBoundingClientRect().width + gap : this.track.clientWidth * 0.8;
        }

        go(dir) {
          const rtl = getComputedStyle(this.track).direction === 'rtl' ? -1 : 1;
          const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.track.scrollBy({ left: dir * rtl * this.step(), behavior: reduce ? 'auto' : 'smooth' });
        }

        update() {
          const t = this.track;
          const max = t.scrollWidth - t.clientWidth;
          const overflow = max > 2;
          this.toggleAttribute('data-overflow', overflow);
          const x = Math.abs(t.scrollLeft);
          this.prev.disabled = !overflow || x <= 2;
          this.next.disabled = !overflow || x >= max - 2;
          // Centre the arrows on the photos, not on the photo + caption
          const media = t.querySelector('.vb-styled__media');
          if (media) this.style.setProperty('--vb-styled-arrow-y', `${media.offsetTop + media.offsetHeight / 2}px`);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vb-usp-bar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('vb-usp-bar')) {
    /**
     * One-item carousel for the USP bar below 990px. Arrows step one item and wrap around;
     * swiping uses native scroll snap. Above 990px every item is visible and the arrows hide.
     */
    class VbUspBar extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-vb-usp-track]');
        this.prev = this.querySelector('[data-vb-usp-prev]');
        this.next = this.querySelector('[data-vb-usp-next]');
        this.onPrev = () => this.step(-1);
        this.onNext = () => this.step(1);
        this.prev?.addEventListener('click', this.onPrev);
        this.next?.addEventListener('click', this.onNext);

        // Flag slides whose icon + label would overflow, so CSS can drop the icon on narrow phones
        if (this.track && 'ResizeObserver' in window) {
          this.observer = new ResizeObserver(() => this.fit());
          this.observer.observe(this.track);
        }
      }

      disconnectedCallback() {
        this.prev?.removeEventListener('click', this.onPrev);
        this.next?.removeEventListener('click', this.onNext);
        this.observer?.disconnect();
      }

      fit() {
        const items = this.track?.children ?? [];
        for (const item of items) {
          const content = item.querySelector('.vb-usp__content');
          if (!content) continue;
          content.classList.remove('vb-usp__content--tight');
          const tight = content.scrollWidth > item.clientWidth + 1;
          content.classList.toggle('vb-usp__content--tight', tight);
        }
      }

      /** @param {number} direction */
      step(direction) {
        const track = this.track;
        if (!track) return;
        const items = track.children.length;
        const width = track.clientWidth || 1;
        const current = Math.round(track.scrollLeft / width);
        const target = (current + direction + items) % items;
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        track.scrollTo({ left: target * width, behavior: reduce ? 'instant' : 'smooth' });
      }
    }

    customElements.define('vb-usp-bar', VbUspBar);
  }

  } catch(e) { console.error(e); }
})();
})();
